// extracted by mini-css-extract-plugin
export default {"root":"CardTitle_root__MO-ED","underlined":"CardTitle_underlined__O9ApZ"};